(ns teamoesterreich.admin-mode.dashboard.dashboard
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.markdown :refer [md]]
            [teamoesterreich.admin-mode.data.webHelpText :as d-webHelpText]

            ))

;(def !data-cache (r/atom {:loaded nil :device {} :device {} :device {}}))


(defn get-data [!st]
  (js/console.log "get-data")
  (let []
    (d-webHelpText/get-entry-by-page :dashboard
                                     (fn [response]
                                       (swap! !st assoc :loaded true :data response)))
    ))


(defn get-it []
  (let [!st (r/atom {:loaded false :edit-mode nil})
        !data (r/cursor !st [:data])
        !loaded (r/cursor !st [:loaded])
        ]
    (fn []
      ;(js/console.log "dashboard rerender" @!st)
      [mui/grid
       {:container  true
        :direction  "row"
        :spacing    1
        :justify    "space-between"
        :alignItems "flex-start"
        :style      {:height "calc(100% - 145px)"}
        }


       (when-not @!loaded
         (get-data !st)
         [mui/grid
          {:item true
           :lg   12
           :xs   12
           }
          [mui/paper
           {}
           [:h1 "Admin Mode"]
           [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40 :style {:margin "10px 0px 10px 0px"}}]
           [mui/typography {} "Lade Daten ... "]
           ]
          ])




       (when @!loaded
         [mui/grid
          {:item true
           :xl   10
           :xs   12
           }
          [mui/card-header
           {:title "Admin Info"}]

          [mui/card-content

           [:div {:dangerouslySetInnerHTML {:__html (.render md (or (:webHelpText-longContent @!data) "Admin Info ...."))}
                  :className               "editor-preview-widget"
                  :style                   {:margin-left "5px" :display "inline-block" :vertical-align "top" :minHeight "200px" :padding "10px" :textAlign "left"}}]

           ]])




       [mui/grid
        {:item true
         :xs   12
         } "  "]
       ]

      )))
